// extracted by css-extract-rspack-plugin
export default {"title":"content-editor-plugin-title-Title-title-5a8bbc5e"};